<template>
    <div class="pb-5" style="background: #182a4d !important; min-height: 100vh">
        <div class="form-group pt-4 d-flex justify-content-between px-2" style="width: 100%">
            <div>
                <input v-model="name" type="text" class="form-control game-search" placeholder="Search Game Name">
            </div>
            <div class="provider-dropdown">
                <DropdownMenu>
                    <DropdownItem v-model="gameType" :options="option1" />
                </DropdownMenu>
            </div>
        </div>
        <div class="p-0 d-flex flex-wrap mb-5 justify-content-center flex-shrink-1 px-1" style="width: 100%">
            <div
                class="card game-card p-0 m-1"
                v-show="game.provider !== 'Blueprint'"
                v-for="(game, index) in newGames.length > 0 ? newGames : games"
                :key="index"
                @click="gameInit(game)"
            >
                <img
                    :src="'https://api.prerelease-env.biz/game_pic/rec/325/'+game.gameID+'.png'"
                    alt=""
                    style="width: 100%; height: 100%; border-top-right-radius: 6px; border-top-left-radius: 6px;"
                />
                <h5 class="" style="color: #fff; text-align: center; padding: 5px 3px 0 3px; text-overflow: ellipsis; overflow: hidden; width: 100%; white-space: nowrap; ">{{game.gameName}}</h5>
            </div>
        </div>
    </div>
</template>
<script>
import { DropdownMenu, DropdownItem } from 'vant';
import {
  getGameUrlFromGamesUrlResponse,
  getGameUrlMissingLaunchBody,
} from '@/utils/gameUrlApiError';
import { showGameUrlErrorDialog, showGameUrlClientError } from '@/utils/showGameUrlErrorDialog';

export default {
  components: { DropdownMenu, DropdownItem },

  data() {
    return {
      games: [],
      rows: 0,
      gameType: 'all',
      name: null,
      newGames: [],
      option1: [
        { text: 'All', value: 'all' },
        { text: 'Slot Games', value: 'vs' },
        // { text: 'Live Casinos', value: 'lg' },
      ],
    };
  },
  methods: {
    detectMob() {
      let check = false;
      /* eslint-disable */
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a,
          )
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                      a.substr(0, 4),
                    )
        ) { check = true; }
      }(navigator.userAgent || navigator.vendor || window.opera));
      return check;
    },
    async fetchGames() {
      try {
        const res = await axios.get('/games', {
          params: {
            // page: 1,
            // limit: this.provider === 'all' ? 200 : 10000,
            // is_mobile: this.detectMob(),
            // type: this.gameType,
            // name: this.name,
          },
        });

        // const result = JSON.parse(res.data.data);
        // this.rows = result['_meta'].pageCount =
        // console.log('result', result);
        this.games = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },

    async gameInit(game) {
      try {
        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            userId: this.$store.state.authUser.id,
            // userName: this.$auth.user().name,
            // currency: 'usd',
            // `session_id`: `string`, `required`
            // returnUrl: 'https://xbet99.vip',
            // isLobby: game.has_lobby,
            // `language`: `string`, `optional`
            // `email`: `string`, `optional`
          },
        });
        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (!launchUrl) {
          const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
          showGameUrlClientError(getGameUrlMissingLaunchBody(res, lang), lang);
          return;
        }
        window.location.assign(launchUrl);
      } catch (error) {
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },
  },
  watch: {
    gameType() {
      this.newGames = this.games.filter((game) => game.gameTypeID.includes(this.gameType));
    },
    name() {
      this.newGames = this.games.filter((game) => game.gameName.includes(this.name));
    },
  },
  mounted() {
    this.fetchGames();
  },
};
</script>
<style scoped>
.provider-dropdown {
    width: 130px;
    height: 40px;
}

.game-search {
    width: 230px !important;
    height: 40px;
    border: 1px solid #1D5D9B;
    background: transparent;
}

::-webkit-input-placeholder { /* Edge */
  color: black;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
}

::placeholder {
  color: #e2dfdf;
}

.game-search:active, .game-search:focus {
    border: 1px solid black !important;
}

.game-card {
    box-shadow: rgba(0, 0, 255, 0.25) 0px 2px 5px -1px,
        rgba(255, 255, 255, 0.3) 0px 1px 3px -1px !important;
    flex-basis: 30% !important;
    flex-grow: 1;
    height: 150px;
    background: #000;
}
</style>
